<div class="row">
  <div class="col-12 col-sm-6" *ngIf="to.title">
    <h5>{{ to.title }}</h5>
  </div>
  <div class="col-12 col-sm-6">
    <mat-slide-toggle [checked]="to.checked" (change)="onChange($event.checked)">
    </mat-slide-toggle>
    <mat-label class="ml-2" color="primary" *ngIf="to.customLabel">{{ to.customLabel }}</mat-label>
  </div>
</div>